import burger from "./parts/burger"
import tabs from "./parts/tabs"
import playPause from "./parts/play-pause"
import navItemsDropdown from "./parts/nav-items-dropdown"
import navbarScroll from "./parts/navbar-scroll"
import counter from "./parts/counter"
import offerGallery from "./parts/offer-gallery"
import searchMagazyny from "./parts/search-magazyny"
import searchBiura from "./parts/search-biura"
import searchGrunty from "./parts/search-grunty"
import compere from "./parts/compere"
import favorite from "./parts/favorite"
import {offerQuestion} from "./parts/offer-question";
import {postsGrid} from "./parts/posts-grid";
import {contactBar} from "./parts/contact-bar";

document.addEventListener("DOMContentLoaded", () =>
{
    burger()
    tabs()
    playPause()
    navItemsDropdown()
    navbarScroll()
    counter()
    offerGallery()
    searchMagazyny()
    searchBiura()
    searchGrunty()
    compere()
    favorite()
    offerQuestion()
    postsGrid()
    contactBar()

    const filtersBtns = document.querySelectorAll("[data-additional]"),
        filters = document.querySelector(".search-bar__additional")

    if (!filtersBtns || filtersBtns.lenth === 0) return

    filtersBtns.forEach((filtersBtn) =>
    {
        filtersBtn.addEventListener("click", function ()
        {
            const target = this.getAttribute("data-additional")

            if (target)
            {
                const targetFilter = document.querySelector(
                    `[data-additionalfor="${target}"]`
                )

                targetFilter.classList.toggle("show")
            }
            else
            {
                filters.classList.toggle("show")
            }
        })
    })
})
